import { NavLink } from "react-router-dom";
import SocialIcons from "./SocialIcons";
import profile from "../_data/profile.json";

/**
 * Represents the footer section of the website.
 *
 * @component
 */

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="siteFooter">
      <div className="container footerInner">
        <div className="footerBrand">
          <p className="footerName">{profile.name}</p>
          <p>
            {profile.title} · {profile.location}
          </p>
          {profile.localizedTaglines.map((t) => (
            <p key={t.lang} lang={t.lang} className="footerLocalized">
              {t.text}
            </p>
          ))}
        </div>
        <nav className="footerNav" aria-label="Footer navigation">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/portfolio">Portfolio</NavLink>
          <NavLink to="/resume">Resume</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <a href={profile.cv.pdf} download>
            Download CV
          </a>
        </nav>
        <div className="footerSocial">
          <SocialIcons />
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
        </div>
      </div>
      <p className="copyright">
        © {currentYear} {profile.name}. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
